import { render, staticRenderFns } from "./RemoveTagModal.vue?vue&type=template&id=7dbd51e8&scoped=true&"
import script from "./RemoveTagModal.vue?vue&type=script&lang=js&"
export * from "./RemoveTagModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveTagModal.vue?vue&type=style&index=0&id=7dbd51e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbd51e8",
  null
  
)

export default component.exports